(() => {
  const BFMModal = () => {
    const selectors = {
      bfmModal: ".bfm-modal",
    };
    const init = () => {
      const closeIcon = document.querySelector(".js-bfm-modal-section .js-btn-close");
      const modalContainer = document.querySelector(".js-bfm-modal-section .js-bfm-modal-container");

      closeIcon.onclick = () => {
        closeIcon.closest(".js-bfm-modal-section").style.display = "none";
        modalContainer.innerHTML = "";
        document.body.classList.remove("mod--menu-open");
      };
    };
    if (document.querySelector(selectors.bfmModal)) {
      init();
    }
  };
  document.addEventListener("DOMContentLoaded", BFMModal);
})();
